// Helpers
import { roundUpToNearest500 } from "@DataPages/helpers/salesOperations/salesLog/utils";

// Context
import { useSalesLogChart } from "@DataPages/context/salesOperations/salesLog/SalesLogChartsContext";

// Components
import { normalizedAngle } from "@DataPages/components/SalesOperations/Tabs/SalesLog/SpeedometerChart";

// Types
import { IDynamicPVRInfo } from "@DataPages/types/salesOperations/salesLog/model";

/*************************************************** HELPERS ************************************************/
const getPillStyle = function (angle: number) {
	const LOW_ANGLE = 120;
	const MEDIUM_ANGLE = 60;
	const HIGH_ANGLE = 0;

	const styles = { label: "LOW", bgColor: "lightblue" };

	switch (true) {
		case angle >= LOW_ANGLE:
			styles.label = "LOW";
			styles.bgColor = "#B3B3B3";
			break;
		case angle >= MEDIUM_ANGLE:
			styles.label = "MEDIUM";
			styles.bgColor = "#2357BE";
			break;
		case angle >= HIGH_ANGLE:
			styles.label = "HIGH";
			styles.bgColor = "#2357BE";
			break;
		default:
			return styles;
	}
	return styles;
};

type CustomPillProps = {
	value: number;
	maxValue: number;
	dynamicPVRInfo: IDynamicPVRInfo;
	isHoveringChart: boolean;
	viewBox?: { cx: number; cy: number };
};
export default function CustomPill(props: Readonly<CustomPillProps>) {
	const { cx, cy } = props.viewBox ?? { cx: 0, cy: 0 };

	const { filteredRows, shouldReCalculateAnalytics } = useSalesLogChart();
	const newMaxValue = shouldReCalculateAnalytics ? roundUpToNearest500(props.dynamicPVRInfo?.maxValue) : props.maxValue;

	const ang = normalizedAngle(
		Math.min(props.value, newMaxValue),
		props.isHoveringChart ? roundUpToNearest500(props.dynamicPVRInfo?.minValue) : 0,
		props.isHoveringChart ? roundUpToNearest500(props.dynamicPVRInfo?.maxValue) : newMaxValue
	);

	let { label, bgColor } = getPillStyle(ang);

	if (shouldReCalculateAnalytics && !filteredRows.length) {
		label = "NO DATA";
	}

	return (
		<>
			<rect
				key={1}
				x={cx - 40}
				y={cy - 20}
				rx="10"
				ry="10"
				width="90px"
				height="17"
				style={{ fill: bgColor, stroke: "none", strokeWidth: "2px" }}
			/>
			,
			<text key={2} x={cx + 5} y={cy - 7.5} textAnchor="middle" fill="white" fontSize={10} fontFamily={"Montserrat"} fontStyle={4}>
				{label}
			</text>
			,
			<circle key={3} cx={cx - 30} cy={cy - 11.5} r="3" fill={"white"} />
		</>
	);
}
